import { injectReducer } from '../../store/reducers'
import PatientDatabase from '../PatientDatabase'
import PatientDetail from '../PatientDetail'

export default (store) => ({
  path: '',
  indexRoute: PatientDatabase(store),
  childRoutes: [
  	PatientDetail(store)
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Home = require('./containers/HomeContainer').default;
      const reducer = require('./modules/home').default;
      injectReducer(store, { key: 'home', reducer });
      cb(null, Home);
    }, 'home')
  }
})


// WEBPACK FOOTER //
// ./src/routes/Home/index.js